import FormSelectInput from "./FormSelectInput";

const FormSelectSafetyFormFilter = (props) => {
    const loadOptions = async (input) => {
        return [
            { value: 'byCustomer', label: 'Customer' },
            { value: 'byDate', label: 'Date' },
            { value: 'byForeman', label: 'Foreman' },
            { value: 'byAuthor', label: 'Author' },
            { value: 'byLocation', label: 'Location' },
        ]
    }

    return (
        <FormSelectInput loadOptions={loadOptions} {...props} />
    )
}

export default FormSelectSafetyFormFilter;